import { Form } from 'antd';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxInputNumber } from 'components/RevxInputNumber';
import { JobOptionSvc } from 'domains/jobconfigDomain';
import { UOMCoefficientEnum } from 'domains/svcDomain';
import { FieldError } from 'rc-field-form/lib/interface';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useOneofId } from '../hook/useOneofId';
import { IOneofProps } from '../OneOfSvcs';

interface Iprops extends IOneofProps {
  formErrorTip?: FieldError[];
  svc?: JobOptionSvc;
}

const CommonOneofSvcQuantityPerBundle = (props: Iprops) => {
  const { svcGroup, formCache, formErrorTip, svc, disabled } = props;

  const id = useOneofId(props);
  const { t } = useTranslation();

  // const configItem = useAppSelector((state) => state.jobConfig.configItem);

  // const spec = getSelectedSpecItem(configItem).spec;

  const svcDisabled = useMemo(() => {
    return !svcGroup?.isRequired && !formCache?.[id]?.name;
  }, [formCache, id, svcGroup?.isRequired]);

  const checkQuantity = useCallback(
    (_: any, value: number) => {
      if (!value && !svcDisabled) {
        return Promise.reject(t('common.pleaseEnter'));
      }
      if (svcDisabled || value) {
        return Promise.resolve();
      }
      // if (value && spec.quantity / value !== ((spec.quantity / value) | 0)) {
      //   return Promise.reject(
      //     'The number of bundles needs to be divisible by the job quantity'
      //   );
      // } else {
      //   return Promise.resolve();
      // }
    },
    [svcDisabled, t]
  );

  return (
    <>
      {Boolean(
        svcGroup?.svcs[0]?.uomCoefficient === UOMCoefficientEnum.BUNDLE_COUNT &&
          svc
      ) && (
        <RevxFlexLayout direction="column" align="top" flexType="inline-flex">
          <div
            className="jobconfig-jobOption-content-label"
            style={{ marginBottom: 14, display: 'inline-block' }}
          >
            Amount per bundle
          </div>
          <Form.Item
            name={[id, 'quantityPerBundle']}
            noStyle
            rules={[
              () => ({
                validator(_, value) {
                  return checkQuantity(_, value);
                },
              }),
            ]}
          >
            <RevxInputNumber
              isInteger
              min={1}
              style={{ marginRight: 10, width: 120, height: 28 }}
              disabled={svcDisabled || disabled}
              // autoFocus={!svcDisabled}
            />
          </Form.Item>
          {formErrorTip?.find(
            (item) =>
              item.name.includes('quantityPerBundle') &&
              item.name.includes(id) &&
              item.errors.length
          )?.errors[0] && (
            <div
              className="ant-form-item-explain-error"
              style={{ marginTop: 6 }}
            >
              {
                formErrorTip?.find(
                  (item) =>
                    item.name.includes('quantityPerBundle') &&
                    item.name.includes(id) &&
                    item.errors.length
                )?.errors[0]
              }
            </div>
          )}
        </RevxFlexLayout>
      )}
    </>
  );
};

export default CommonOneofSvcQuantityPerBundle;
